import { Flame, Search, ShowerHead, Wrench, Droplets, Building2, BadgeCheck, Construction, Gauge, Pipette, ArrowRight } from "lucide-react";
import { PHONE_TEL } from "@/data/marvinContent";

const icons = [Flame, Search, Droplets, ShowerHead, Wrench, Pipette, Gauge, Construction, BadgeCheck, Building2];

export const ServicesPricing = ({ t }) => (
  <>
    <section id="services" data-testid="services-section" className="py-16 sm:py-20">
      <div className="section-shell">
        <div className="mb-9 max-w-3xl text-left">
          <p data-testid="services-label" className="text-sm font-extrabold uppercase tracking-[0.22em] text-amber-600">{t.servicesIntro.label}</p>
          <h2 data-testid="services-title" className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-[#0A2540] sm:text-4xl lg:text-5xl">{t.servicesIntro.title}</h2>
          <p data-testid="services-description" className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">{t.servicesIntro.text}</p>
        </div>
        <div data-testid="services-grid" className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {t.services.map((service, index) => {
            const Icon = icons[index] || Wrench;
            return (
              <article key={service.title} data-testid={`service-card-${index}`} className="group rounded-[1.5rem] border border-slate-200 bg-white p-5 text-left shadow-sm transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-1 hover:border-amber-200 hover:shadow-xl">
                <div data-testid={`service-icon-${index}`} className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-50 text-[#0A2540]"><Icon className="h-6 w-6" aria-hidden="true" /></div>
                <h3 data-testid={`service-title-${index}`} className="font-heading text-xl font-extrabold tracking-tight text-[#0A2540]">{service.title}</h3>
                <p data-testid={`service-text-${index}`} className="mt-2 text-sm leading-6 text-slate-600">{service.text}</p>
                <div className="mt-4 rounded-2xl bg-slate-50 p-4">
                  <p data-testid={`service-signs-label-${index}`} className="text-xs font-extrabold uppercase tracking-[0.18em] text-slate-500">{t.signsLabel}</p>
                  <ul className="mt-2 space-y-1.5">
                    {service.signs.map((sign, signIndex) => <li key={sign} data-testid={`service-sign-${index}-${signIndex}`} className="flex gap-2 text-sm font-semibold text-slate-700"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-amber-500" />{sign}</li>)}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>

    <section id="pricing" data-testid="pricing-section" className="pb-16 sm:pb-20">
      <div className="section-shell grid gap-6 rounded-[2rem] bg-[#0A2540] p-6 text-white shadow-2xl shadow-blue-950/20 sm:p-8 lg:grid-cols-[0.9fr_1.1fr] lg:p-10">
        <div className="text-left">
          <p data-testid="pricing-label" className="text-sm font-extrabold uppercase tracking-[0.22em] text-amber-300">{t.pricing.label}</p>
          <h2 data-testid="pricing-title" className="mt-3 font-heading text-3xl font-extrabold tracking-tight sm:text-4xl">{t.pricing.title}</h2>
          <p data-testid="pricing-description" className="mt-4 text-base leading-relaxed text-blue-100">{t.pricing.text}</p>
        </div>
        <div data-testid="pricing-list" className="grid gap-3">
          {t.pricing.items.map(([name, price], index) => (
            <a key={name} data-testid={`pricing-item-${index}`} href={price.toLowerCase().includes("call") || price.toLowerCase().includes("llamar") ? `tel:${PHONE_TEL}` : "#estimate"} className="flex items-center justify-between gap-4 rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur transition-[transform,background-color] hover:-translate-y-0.5 hover:bg-white/15">
              <span data-testid={`pricing-name-${index}`} className="font-bold text-white">{name}</span>
              <span data-testid={`pricing-price-${index}`} className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-4 py-2 font-heading text-sm font-extrabold text-[#0A2540] sm:text-base">{price}<ArrowRight className="h-4 w-4" aria-hidden="true" /></span>
            </a>
          ))}
        </div>
      </div>
    </section>
  </>
);